// Copyright © Veeam Software Group GmbH

import type { AuthInfo } from 'infrastructure/auth';

import { getLocalStorage } from '../rawStorage';
import { StorageKeys } from '../StorageKeys';

export const authStorage = getLocalStorage<AuthInfo>(StorageKeys.Auth);
